import { useMutation } from "@tanstack/react-query";
import { validateKlaviyoCredentials } from "../../api/bKlaviyoApi";

export const useValidateKlaviyo = () => {
  return useMutation({
    mutationKey: ["validate-klaviyo"],
    mutationFn: (data) => validateKlaviyoCredentials(data),
    onError: (error) => {
      console.error("Klaviyo validation error details:", error.response || error);
    },
  });
};